import asyncLoadFabricImg from "./async-load-fabric-img"
import { logoBaseOpts, placeholderBaseOpts } from "./base-options"
import { fabric } from "fabric"

const managePreview = async ({ props, canvas, rect, logoRef }) => {
  if (props.logoImg !== null) {
    canvas.remove(rect)
    const logoImg = await asyncLoadFabricImg(props.logoImg, {
      selectable: false,
    })
    logoImg.set({
      ...logoBaseOpts,
      ...props.logo,
    })
    logoImg.setCoords()
    console.log("logoR", logoRef)
    console.log("logoR", logoImg)
    logoRef.current = logoImg
    // props.onChangePreview( canvas.toDataURL() );
    return logoImg
  } else {
    if (logoRef) {
      canvas.remove(logoRef.current)
    }
    rect = new fabric.Rect({
      ...placeholderBaseOpts,
      ...props.placeholder,
    })
    props.onChangePreview(null)

    return rect
  }
}

export default managePreview
